var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendToClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696",
    transform: "translate(1.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M10.855,11.685a.705.705,0,0,1-.5-1.2l9.124-9.124a.705.705,0,0,1,1,1l-9.124,9.124A.7.7,0,0,1,10.855,11.685Z",
    transform: "translate(-2.685 -1.15)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M18.445,1.15a.705.705,0,0,1,.666.938L13.3,18.678a.705.705,0,0,1-1.31.053L8.786,11.514,1.569,8.306A.705.705,0,0,1,1.622,7L18.212,1.19A.7.7,0,0,1,18.445,1.15ZM12.56,16.533,17.3,3,3.767,7.739l5.84,2.6a.705.705,0,0,1,.358.358Z",
    transform: "translate(-1.15 -1.15)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToClient);
export default __webpack_public_path__ + "static/media/sendToClient.6fb7766f5eef222da2637c009eea82a5.svg";
export { ForwardRef as ReactComponent };